import { useNavigate, useParams } from 'react-router-dom'

import { Box, Button } from '@factorialco/deprecated-design-system'

import Modal from 'modules/core/components/Modal'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

import { useDeleteTrainingMemberships } from 'modules/trainings/hooks/TrainingMemberships/useDeleteTrainingMemberships'

interface Props {
  membershipIds: number[]
}

export const DeleteParticipantsModal = ({ membershipIds }: Props) => {
  const { navigation } = useNavigation()
  const navigate = useNavigate()
  const { id } = useParams()
  const { deleteTrainingMemberships } = useDeleteTrainingMemberships()
  const onSubmit = async () => {
    const response = await deleteTrainingMemberships({ ids: membershipIds })

    const handled = handleResult(response, () => {
      app.setFlash({
        type: 'wrong',
        message: i18n.t(
          'trainings.trainings_revamp.training_detail.employees_table.delete_participants_modal.error'
        ),
      })
    })

    if (handled.success) {
      app.setFlash({
        type: 'correct',
        message: i18n.t(
          'trainings.trainings_revamp.training_detail.employees_table.delete_participants_modal.success'
        ),
      })

      navigate(
        navigation.trainings.list.details_revamp.view.participants.fullPath({ id: Number(id) })
      )
    }
  }
  const copy =
    membershipIds.length === 1
      ? i18n.t(
          'trainings.trainings_revamp.training_detail.employees_table.delete_participants_modal.title_only_one'
        )
      : i18n.t(
          'trainings.trainings_revamp.training_detail.employees_table.delete_participants_modal.title',
          { count: membershipIds.length }
        )
  return (
    <Modal
      title={copy}
      description={i18n.t(
        'trainings.trainings_revamp.training_detail.employees_table.delete_participants_modal.description'
      )}
      onClose={() =>
        navigate(
          navigation.trainings.list.details_revamp.view.participants.fullPath({ id: Number(id) })
        )
      }
      footer={
        <Box gap="s8" flexDirection="row">
          <Button.Router
            to={{
              pathname: navigation.trainings.list.details_revamp.view.participants.fullPath({
                id: Number(id),
              }),
            }}
            type="secondary"
          >
            {i18n.t('common.cancel')}
          </Button.Router>
          <Button onClick={() => onSubmit()} type="negative">
            {i18n.t('common.delete')}
          </Button>
        </Box>
      }
    ></Modal>
  )
}
